import script from "./PedidoPaso2.vue?vue&type=script&setup=true&lang=js"
export * from "./PedidoPaso2.vue?vue&type=script&setup=true&lang=js"

import "./PedidoPaso2.vue?vue&type=style&index=0&id=5354c5b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5354c5b6"]])

export default __exports__